import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
interface BlogPost {
  category: string;
  title: string;
  date: string;
  image: string;
}
const blogPosts: BlogPost[] = [{
  category: 'Injectables',
  title: 'Botox and Fillers, Everything You Need to Know',
  date: 'January 10, 2025',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&h=340&fit=crop'
}, {
  category: 'Injectables',
  title: 'Platelet-Rich Plasma: What is it? And Does it Work?',
  date: 'January 10, 2025',
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=340&fit=crop'
}, {
  category: 'Face & Skin',
  title: 'What Are the Different Types of Laser Skin Treatments?',
  date: 'January 10, 2025',
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&h=340&fit=crop'
}, {
  category: 'Face & Skin',
  title: 'The Benefits of Halo Laser Technology',
  date: 'January 10, 2025',
  image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=600&h=340&fit=crop'
}, {
  category: 'Featured',
  title: 'Welcome to Be Clinical',
  date: 'January 10, 2025',
  image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=600&h=340&fit=crop'
}, {
  category: 'Face & Skin',
  title: 'Everything You Need to Know About Botox',
  date: 'September 25, 2024',
  image: 'https://images.unsplash.com/photo-1598524374912-6b0b0bdd5e5a?w=600&h=340&fit=crop'
}];
const categories = ['All', 'Face & Skin', 'Injectables', 'Featured'];
function BlogCard({
  post,
  delay
}: {
  post: BlogPost;
  delay: number;
}) {
  return <AnimateOnScroll delay={delay} data-id="element-340">
      <div className="bg-[#111111] overflow-hidden group cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(255,20,147,0.1)]" data-id="element-341">
        {/* Image */}
        <div className="relative aspect-video overflow-hidden" data-id="element-342">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-343" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-344"></div>
          <span className="absolute bottom-3 left-3 bg-[#FF1493] text-white uppercase text-[11px] font-bold tracking-widest px-3.5 py-1.5 font-[Poppins,_sans-serif]" data-id="element-345">
            {post.category}
          </span>
        </div>

        {/* Content */}
        <div className="p-6 lg:p-7" data-id="element-346">
          <h3 className="text-white font-bold text-lg lg:text-xl leading-[1.3] mb-2 font-[Poppins,_sans-serif] line-clamp-2" data-id="element-347">
            {post.title}
          </h3>
          <p className="text-[#666666] text-[13px] font-[Poppins,_sans-serif] mb-4" data-id="element-348">
            {post.date}
          </p>
          <a href="#" className="text-[#FF1493] uppercase text-[13px] font-bold tracking-widest hover:underline font-[Poppins,_sans-serif] inline-flex items-center gap-1" data-id="element-349">
            READ MORE <span data-id="element-350">→</span>
          </a>
        </div>
      </div>
    </AnimateOnScroll>;
}
export function BlogGrid() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredPosts = activeCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === activeCategory);
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-351">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-352">
        {/* Category Filter */}
        <AnimateOnScroll className="mb-12" data-id="element-353">
          <div className="flex flex-wrap justify-center gap-3" data-id="element-354">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-6 py-2.5 rounded-full text-[13px] uppercase font-bold tracking-widest transition-all duration-300 font-[Poppins,_sans-serif] min-h-[44px] ${activeCategory === category ? 'bg-[#FF1493] text-white' : 'bg-transparent border border-[#333333] text-white hover:border-[#FF1493]'}`} data-id="element-355">
                {category}
              </button>)}
          </div>
        </AnimateOnScroll>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-356">
          {filteredPosts.map((post, index) => <BlogCard key={`${activeCategory}-${index}`} post={post} delay={index * 80} data-id="element-357" />)}
        </div>
      </div>
    </section>;
}